export enum PersistentErrorCode {
	invalidCredentialsError = 40004,
	csvManipulationError = 40020,
	csvDateFormat = 40021,
	accountAlreadyConfirmedError = 40027,
	passholderUniqueError = 40036,
	eligiblePriceError = 40037,
	roleNotAllowed = 40038,
}
